// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2f4vw","ranges":"BmiRanges_ranges__3K_iI"};